import request from '@/plugin/axios'

export function getSysUserList (params) {
  return request({
    url: '/v1/electricity/sysUser/queryUser',
    method: 'get',
    params: params
  })
}

export function saveSysUserList (data) {
  return request({
    url: '/v1/electricity/sysUser/saveUser',
    method: 'post',
    data
  })
}

export function updateSysUserList (data) {
  return request({
    url: '/v1/electricity/sysUser/updateUser',
    method: 'put',
    data
  })
}

export function deleteSysUserList (data) {
  return request({
    url: '/v1/electricity/sysUser/deleteUser',
    method: 'DELETE',
    headers: {
      'Content-Type': 'x-www-form-urlencoded'
    },
    params: data
  })
}

export function updateUserPwd (data) {
  return request({
    url: '/v1/electricity/sysUser/updateUserPwd',
    method: 'put',
    data
  })
}
